export const SIM_VERSION = 5;
export const MAP_W = 60;
export const BASE_H = 43;
export const TIER_ROWS = 9;
export const BASE_FLEET = 24;
export const TIER_STEP = 6;
export const MAX_TIER = 6;
export const BASE_AI = 20;
export const FLEET_CAP = BASE_FLEET + TIER_STEP * MAX_TIER; // 60 vehicles at Tier 6
export const TICK_MIN = 0.1; // game-minutes per tick at 1x (10 Hz => 1 real s = 1 game min)
export const MAX_HUMAN_STEP_DT = 0.02; // fixed Euler sub-step ceiling for client/server stepHuman parity
export const DAY_START = 6 * 60; // 06:00
export const BACKLOG_CAP = 60;
export const KWH_PER_PCT = 0.24;
export const INCIDENT_PENALTY = 15;
export const INTERACT_REACH = 1.6;
export const REACH = INTERACT_REACH;
export const SITES = ['den-1', 'slc-2', 'phx-3', 'abq-4'];
export const SITE_THEMES = {
    'den-1': {
        id: 'den-1',
        name: 'Denver Fulfillment Hub',
        shortName: 'Logistics Hub',
        city: 'Denver, CO',
        cargoStyle: 'boxes',
        cargoLabel: 'Cardboard & Cold Pallets',
        skuPrefix: 'SKU',
        skuItems: ['CARTON', 'CRATE', 'PALLET', 'PARCEL', 'TOTE', 'CASE'],
        accentColor: '#d97706',
    },
    'slc-2': {
        id: 'slc-2',
        name: 'Salt Lake Botanical Conservatory',
        shortName: 'Botanical Nursery',
        city: 'Salt Lake City, UT',
        cargoStyle: 'plants',
        cargoLabel: 'Potted Trees & Terrariums',
        skuPrefix: 'PLT',
        skuItems: ['MONSTERA', 'FICUS', 'ORCHID', 'BONSAI', 'SUCCULENT', 'FERN'],
        accentColor: '#16a34a',
    },
    'phx-3': {
        id: 'phx-3',
        name: 'Phoenix Silicon Cleanroom',
        shortName: 'Silicon Fab',
        city: 'Phoenix, AZ',
        cargoStyle: 'tech',
        cargoLabel: 'Wafer FOUPs & Server Blades',
        skuPrefix: 'FAB',
        skuItems: ['FOUP-300', 'WAFER-5N', 'GPU-RACK', 'CRYO-CELL', 'OPTIC-MOD', 'LITHO-KIT'],
        accentColor: '#0284c7',
    },
    'abq-4': {
        id: 'abq-4',
        name: 'Albuquerque Artisan Roastery',
        shortName: 'Artisan Roastery',
        city: 'Albuquerque, NM',
        cargoStyle: 'artisan',
        cargoLabel: 'Oak Barrels & Burlap Sacks',
        skuPrefix: 'ART',
        skuItems: ['CASK-OAK', 'BURLAP-60', 'COPPER-URN', 'CLAY-AMPH', 'ROAST-LOT', 'SPICE-BAL'],
        accentColor: '#c2410c',
    },
};
const REGION_BASE_THEME_KEY = {
    den: 'den-1',
    slc: 'slc-2',
    phx: 'phx-3',
    abq: 'abq-4',
};
export function getSiteTheme(siteId) {
    if (siteId && siteId in SITE_THEMES) {
        return SITE_THEMES[siteId];
    }
    if (siteId) {
        const match = /^(den|slc|phx|abq)-(\d+)$/i.exec(siteId.trim());
        if (match) {
            const prefix = match[1].toLowerCase();
            const num = match[2];
            const baseKey = REGION_BASE_THEME_KEY[prefix] ?? 'den-1';
            const base = SITE_THEMES[baseKey];
            const normalizedId = `${prefix}-${num}`;
            return {
                ...base,
                id: normalizedId,
                code: normalizedId.toUpperCase(),
                name: `${base.city} #${num}`,
                title: `${base.city} Annex #${num}`,
            };
        }
    }
    return SITE_THEMES['den-1'];
}
export const BLITZ_DURATION_MIN = 180; // 180 sim-min = 180 real seconds (3 real min) at 10 Hz (0.1 sim-min/tick)
export const RUN_CARD_GRACE_MIN = 15; // informational card-pick window (runGraceUntil); the Blitz clock itself starts only on first input, keepCards, or Co-Pilot
/** Every card type (all dealable; `humanOnly` cards are never dealt to AI agents). */
export const CARD_TYPE_IDS = [
    'route',
    'batch',
    'clean',
    'ontime',
    'quick',
    'charge',
    'overdrive',
    'long_reach',
    'eco_cell',
    'high_roller',
    'long_haul',
    'local_hero',
    'beat_planner',
    'poacher',
    'trailer_closer',
    'crazy_stop',
    'combo_king',
    'double_nothing',
    'rival_grudge',
    'ghost_hunter',
    'last_call',
];
//# sourceMappingURL=types.js.map